// extracted by mini-css-extract-plugin
module.exports = {"preview":"YouTubeVideo_preview__1e8oy"};